import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { channelByIdQuery } from '@/entities/channel/queries';
import { ApiError } from '@/shared/api/ApiError';
import { IChannelDetailsDto } from '@/shared/api/channels';
import { useNotifications } from '@/shared/ui/Notifications';

export function useChannelByIdImperative() {
  const queryClient = useQueryClient();
  const { addNotification } = useNotifications();

  const fetchChannelById = useCallback(
    async (channelId: string): Promise<IChannelDetailsDto | undefined> => {
      try {
        return await queryClient.fetchQuery({
          ...channelByIdQuery(channelId),
          staleTime: 0,
        });
      } catch (error) {
        const apiError = error as ApiError;
        if (ApiError.isCanceledError(apiError)) {
          return;
        }
        addNotification({
          type: 'error',
          title: apiError.message,
          caption: apiError.data?.details,
        });
      }
    },
    [queryClient, addNotification]
  );

  return { fetchChannelById };
}
